import { createTheme, ThemeProvider } from '@mui/material/styles';
import { BrowserRouter, Switch } from "react-router-dom";
import { PrivateRoute, PublicRoute } from "./components/auth";
import { Dashboard, Login } from "./pages";

const BARLEY_500 = 'rgba(151,173,105,1)';
// const BARLEY_400 = 'rgba(227,245,155,1)';
// const BARLEY_600 = 'rgba(119,143,69,1)';
// const lentil_500 = 'rgba(67,74,56,1)';
// const lentil_400 = rgba(118,128,102,1);
// const lentil_600 = rgba(42,49,32,1);
const EARTH_500 = 'rgba(6,8,8,1)';
// const EARTH_400 = rgba(116,112,110,1);
const EARTH_70_OVERLAY = 'rgba(6,8,8,0.700)';
// const stroke_grey = rgba(6,8,8,0.100);
// const stroke_white = rgba(255,255,255,0.100);
// const neutrals_white = rgba(255,255,255,1);  
const NEUTRALS_SAND_500 = 'rgba(245,245,239,1)';
// const neutrals_sand_600 = rgba(222,222,217,1);
// const SORGHUM_500 = 'rgba(206,107,41,1)';
// const sorghum_600 = rgba(176,94,40,1);
// const sorghum_400 = rgba(251,223,205,1);
// const WHEAT_500 = 'rgba(215,180,82,1)';
// const WHEAT_600 = 'rgba(170,143,66,1)';
// const WHEAT_400 = rgba(253,233,179,1);
// const canola_500 = rgba(238,193,32,1);
// const canola_600 = rgba(211,171,23,1);
// const canola_400 = rgba(255,238,176,1);
// const CHICKPEA_500 = 'rgba(86,134,91,1)';
// const chickpea_600 = rgba(68,107,72,1);
// const chickpea_400 = rgba(214,248,206,1);
// const sky_500 = rgba(61,146,184,1);
// const sky_600 = rgba(50,125,158,1);
// const sky_400 = rgba(210,232,242,1);

const PRIMARY = BARLEY_500;
const SECONDARY = EARTH_70_OVERLAY;
// const PRIMARY_TEXT = EARTH_500;
// const STATUS_YELLOW = '#FFB946';
// const STATUS_RED = '#F7685B';
// const STATUS_PURPLE = '#88AF8';
// const ACCENT_BLUE = '#109CF1';
// const GRAY = '#818E9B';
// const GRAY_LIGHTER = '#F5F6F8';
// const WHITE = '#FFFFFF';  
// const SWITCH_DISABLED_PRIMARY = BARLEY_400;
const DEFAULT_COLOR = EARTH_500;
const ERROR = 'rgba(255,0,0,1)';




const theme = createTheme({
  palette: {
    text: {
      primary: EARTH_500,
      secondary: SECONDARY,
      // default: PRIMARY_TEXT,
    },
    primary: {
      main: PRIMARY,
      dark: PRIMARY,
      contrastText: DEFAULT_COLOR,
    },
    secondary: {
      main: SECONDARY,
      contrastText: DEFAULT_COLOR,
    },
  },
  typography: {
    // Use the system font instead of the default Roboto font.
    fontFamily: ['Founders Grotesk Regular', 'Founders Grotesk X-Condensed Semibold', 'sans-serif'].join(','),
  },
  components: {
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          marginLeft: 0,
          marginRight: 0
        }
      }
    },
    MuiButtonBase: {
      styleOverrides: {
        focusVisible: false,
        root: {
          outline: 'none !important',
        }
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          '&.largeButton': {
            padding: '28px 48px',
            fontWeight: 600,
            fontSize: '18px',
            height: '60px',
            lineHeight: '24px',
          },
          '&.default': {
            borderColor: DEFAULT_COLOR,
            color: DEFAULT_COLOR,
            fontWeight: 600,
            fontSize: '15px',
          },  
          borderRadius: 100,
        },
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        input: {
          "&:-webkit-autofill": {
            "-webkit-box-shadow": "0 0 0 100px rgba(255,255,255,1) inset",
            "-webkit-text-fill-color": "var(--EARTH_500)",
          },
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          height: '64px',
          borderRadius: 4,
          padding: '20px 16px',
          color: EARTH_500,
          fontSize: 18,
          '&.Mui-focused ': {
            boxShadow: `0 0 8px 2px rgba(227,245,155,0.5)`,
          },
          '&.Mui-error ': {
            borderColor: ERROR,
            boxShadow: `0 0 8px 2px ${ERROR}`,
          },
        },
        input: {
          '&.Mui-focused': {
          },
        },
      }
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: NEUTRALS_SAND_500,
        },
      },
    },
    MuiTabs: {
      defaultProps: {
        scrollButtons: 'auto',
      },
      styleOverrides: {
        root: {
          backgroundColor: NEUTRALS_SAND_500,
        },
        indicator: {
          height: 4,
          outline: 'none'
        }
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          color: EARTH_70_OVERLAY,
          fontWeight: 400,
          fontFamily: 'Founders Grotesk Regular',
          fontSize: 18,
          lineHeight: '24px',
          '&.Mui-selected': {
            color: EARTH_500,
          },
        },
      },
    }
  },
});


function App() {
  return (
    <ThemeProvider theme={theme}>{
      <BrowserRouter>
        <Switch>
          {/* <PublicRoute restricted={false} component={Home} path="/" exact /> */}
          <PublicRoute restricted={false} component={Login} path="/" exact />
          <PublicRoute
            restricted={false}
            component={Login}
            path="/auth/login"
            exact
          />
          <PrivateRoute component={Dashboard} path="/dashboard" exact />
          {/* <PublicRoute component={Dashboard} path="/dashboard" exact /> */}
        </Switch>
      </BrowserRouter>
    }</ThemeProvider>
  );
}

export default App;
